import React from 'react';

import useUpdateAccessToken from '@/hooks/useUpdateAccessToken';
import UpdateBanner from '@/components/Layouts/User/UpdateBanner';

import useCheckOverPeriod from '../TopBanner/useCheckOverPeriod';
import { TARGET_DATE } from '../TopBanner';

import Header from './Header';
import * as Styled from './index.styles';

interface Props {
  isReverseGridTemplateColumns?: boolean;
  nav?: React.ReactNode;
}

const UserLayout = ({
  isReverseGridTemplateColumns = false,
  nav,
  children,
}: React.PropsWithChildren<Props>) => {
  const { isValid } = useCheckOverPeriod({ targetDate: TARGET_DATE });

  useUpdateAccessToken();

  return (
    <Styled.Wrapper>
      <Header />
      <UpdateBanner />
      <Styled.InnerWrapper
        direction="column"
        padding={{ top: isValid ? 30 : 0, bottom: 180 }}
      >
        {nav && <Styled.NavWrapper>{nav}</Styled.NavWrapper>}
        <Styled.Main
          isReverseGridTemplateColumns={isReverseGridTemplateColumns}
          hasNav={nav == undefined}
          className={'main'}
        >
          {children}
        </Styled.Main>
      </Styled.InnerWrapper>
    </Styled.Wrapper>
  );
};

export default UserLayout;
